const validQuantity = (value) => value != null && value !== "" && Number.isFinite(Number(value)) && Number(value) >= 0;
const isCurrent = (record) => !["stale", "unavailable", "not-calculated"].includes(record.calculationStatus);

export const summarizeYearMilk = (records = []) => {
    const sum = (field) => records.length > 0 && records.every((record) => isCurrent(record) && validQuantity(record[field]))
        ? Number(records.reduce((total, record) => total + Number(record[field]), 0).toFixed(3)) : null;
    return { milk: sum("totalMilk"), standardMilk: sum("totalStandardMilk"), duration: sum("totalDuration"),
        partial: records.some((record) => record.calculationStatus === "partial"),
        ongoing: records.some((record) => record.periodState === "ongoing"),
        predicted: records.some((record) => ["predicted", "legacy-prediction"].includes(record.calculation?.standardMethod)),
        methods: [...new Set(records.map((record) => ({
            "legacy-hours": "Α", AT: "AT", AC: "AC", "AC-with-fallback": "AC/Ω", "interval-fallback": "Ω",
            "full-day-sum": "Σ", "legacy-daily-total": "Ι",
        }[record.calculation?.recordingMethod] || "?")))].join("/"),
    };
};

export const getMilkReportYears = (now = new Date()) => {
    const parts = new Intl.DateTimeFormat("en-US", { timeZone: "Europe/Athens", year: "numeric", month: "numeric" }).formatToParts(now);
    const year = Number(parts.find((part) => part.type === "year").value);
    const month = Number(parts.find((part) => part.type === "month").value);
    const latest = year - Number(month < 8);
    const count = month < 8 ? 9 : 10;
    return Array.from({ length: count }, (_, index) => {
        const start = latest - count + 1 + index;
        return `${start}-${start + 1}`;
    });
};
